"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leafSchemaBeet = exports.isLeafSchemaV1 = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const isLeafSchemaV1 = (x) => x.__kind === 'V1';
exports.isLeafSchemaV1 = isLeafSchemaV1;
exports.leafSchemaBeet = beet.dataEnum([
    [
        'V1',
        new beet.BeetArgsStruct([
            ['id', beetSolana.publicKey],
            ['owner', beetSolana.publicKey],
            ['delegate', beetSolana.publicKey],
            ['nonce', beet.u64],
            ['dataHash', beet.uniformFixedSizeArray(beet.u8, 32)],
            ['creatorHash', beet.uniformFixedSizeArray(beet.u8, 32)],
        ], 'LeafSchemaRecord["V1"]'),
    ],
]);
//# sourceMappingURL=LeafSchema.js.map